import type { MenuItem } from "./SubMenu";

export const menuItems: MenuItem[] = [
  {
    scrollTo: "hero-top",
    label: "Home",
  },
  {
    scrollTo: "about-expand",
    label: "About",
  },
  {
    scrollTo: "contact-expand",
    label: "Contact",
  },
  {
    label: "Projects",
    children: [
      {
        scrollTo: "cultural-exchange-project",
        label: "Cultural Exchange",
      },
      {
        scrollTo: "climate-stories-project",
        label: "Cultural Exchange for Climate Stories",
      },
    ],
  },
];
